export default __webpack_public_path__ + "static/media/GR00058-evening.19d57b5a.svg";